import React from 'react'
import ggPlay from '../images/ggPlay.png';
import appStore from '../images/appStore.png';

export default class MobileLanding extends React.Component {

    render() {
        const body = {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh'
        };


        return (
            <div style={body}>
                <a href={"/#"}> <img src={appStore} style={{maxWidth: '100px'}} alt={'App Store'}/></a>
                <a href={"/#"}><img src={ggPlay} style={{maxWidth: '113px'}} alt={'Google Play'}/></a>
            </div>
        )
    }
}
